<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="640px">
        <div class="row">
            <div class="col-12" v-if="configuration.enabled_item_free">
                <x-switch-left v-model="form.is_item_free"
                               label="Producto libre"
                               is-dense
                               @change="changeIsItemFree"></x-switch-left>
            </div>
            <div class="col-12">
                <x-switch-left v-model="search_item_by_barcode"
                               label="Buscar por código de barras"
                               is-dense
                               :disabled="recordItem != null"></x-switch-left>
            </div>
            <div class="col-12" v-if="search_item_by_barcode">
                <x-switch-left v-model="search_item_by_barcode_presentation"
                               is-dense
                               label="Buscar por presentación"></x-switch-left>
            </div>
            <div class="col-12" v-if="form.is_item_free">
                <x-input v-model="form.item_name" label="Nombre del producto"></x-input>
            </div>
            <div class="col-12" v-else>
                <div id="custom-select"
                     :class="{'has-danger': errors.item_id}"
                     class="form-group">
                    <label class="control-label">
                        Producto/Servicio
                        <a v-if="can_add_new_product"
                           href="#"
                           @click.prevent="showDialogNewItem = true">
                            [+ Nuevo]
                        </a>
                    </label>
                    <template v-if="!search_item_by_barcode"
                              id="select-append">
                        <el-input id="custom-input">
                            <el-select id="select-width"
                                       ref="selectSearchNormal"
                                       slot="prepend"
                                       v-model="form.item_id"
                                       :disabled="recordItem != null"
                                       :loading="loading_search"
                                       :remote-method="searchRemoteItems"
                                       filterable
                                       placeholder="Buscar"
                                       popper-class="el-select-items"
                                       remote
                                       :tabindex="'1'"
                                       @change="changeItem"
                                       @focus="focusSelectItem"
                                       @visible-change="focusTotalItem">
                                <el-tooltip v-for="option in items"
                                            :key="option.id"
                                            placement="left">
                                    <div slot="content"
                                         v-html="ItemSlotTooltipView(option)"></div>
                                    <el-option :label="ItemOptionDescriptionView(option)"
                                               :value="option.id"></el-option>
                                </el-tooltip>
                            </el-select>
                        </el-input>
                    </template>
                    <template v-else>
                        <el-input id="custom-input">
                            <el-select
                                id="select-width"
                                ref="selectBarcode"
                                slot="prepend"
                                v-model="form.item_id"
                                :disabled="recordItem != null"
                                :loading="loading_search"
                                :remote-method="searchRemoteItems"
                                filterable
                                placeholder="Buscar"
                                popper-class="el-select-items"
                                remote
                                value-key="id"
                                @change="changeItem">
                                <el-option
                                    v-for="option in items"
                                    :key="option.id"
                                    :label="option.full_description"
                                    :value="option.id"></el-option>
                            </el-select>
                            <el-tooltip
                                slot="append"
                                :disabled="recordItem != null"
                                class="item"
                                content="Ver Stock del Producto"
                                effect="dark"
                                placement="bottom">
                                <el-button
                                    :disabled="isEditItemNote"
                                    @click.prevent="clickWarehouseDetail()">
                                    <i class="fa fa-search"></i>
                                </el-button>
                            </el-tooltip>
                        </el-input>
                    </template>
                    <small v-if="errors.item_id"
                           class="form-control-feedback"
                           v-text="errors.item_id[0]"></small>
                </div>
            </div>
            <div class="col-12">
                <a class="text-center font-weight-bold text-info"
                   href="#"
                   v-if="showLots"
                   @click.prevent="clickLotGroup">[&#10004; Seleccionar lote]</a>
                <a class="text-center font-weight-bold text-info"
                   href="#"
                   v-if="showSeries"
                   @click.prevent="clickSelectLots">[&#10004; Seleccionar series]</a>
            </div>
            <div class="col-md-4">
                <x-input v-model="form.quantity"
                         label="Cantidad"
                         :readonly="true"
                         v-if="showSeries || showLots"></x-input>
                <div :class="{'has-danger': errors.quantity}"
                     class="form-group"
                     v-else>
                    <label class="control-label">Cantidad</label>
                    <el-input :tabindex="'2'"
                              ref="inputQuantity"
                              v-model="form.quantity"
                              @blur="validateQuantity"
                              @input.native="changeValidateQuantity">
                        <el-button slot="prepend"
                                   :disabled="form.quantity < 0.01"
                                   icon="el-icon-minus"
                                   style="padding-right: 5px ;padding-left: 12px"
                                   @click="clickDecrease"></el-button>
                        <el-button slot="append"
                                   icon="el-icon-plus"
                                   style="padding-right: 5px ;padding-left: 12px"
                                   @click="clickIncrease"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="col-md-4">
                <x-input v-model="form.weight"
                         label="Peso x unidad(KGM)"></x-input>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label class="control-label">Descripción</label>
                    <vue-ckeditor v-model="form.name_product_pdf"
                                  :editors="editors"
                                  type="classic"></vue-ckeditor>
                </div>
            </div>
            <div class="col-12">
                <x-input v-model="form.comment"
                         label="Comentario"
                         type="textarea"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit" :text="buttonLabel" v-if="form.item_id"></x-button-submit>
            </div>
        </div>

        <item-form :external="true"
                   :showDialog.sync="showDialogNewItem"
                   @success="successItem"></item-form>

        <series-list :showDialog.sync="showDialogSelectLots"
                     :item="form.item"
                     :selected-lots="form.lots"
                     :warehouse-id="configuration.warehouse_id"
                     :table="table"
                     :table-item-id="form.id"
                     @success="successSeries">
        </series-list>

        <lots-group-list :showDialog.sync="showDialogSelectLotsGroup"
                         :item="form.item"
                         :selected-lots-group="form.IdLoteSelected"
                         :warehouse-id="configuration.warehouse_id"
                         @success="successLotsGroup">
        </lots-group-list>
    </x-modal>
</template>

<script>

import ItemForm from '../../items/form.vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor from 'vue-ckeditor5'
import {mapState} from "vuex/dist/vuex.mjs"
import {ItemOptionDescription, ItemSlotTooltip} from "../../../../helpers/modal_item"
import Keypress from "vue-keypress"
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue"
import XInput from "../../../../components/Form/XInput.vue"
import XSelect from "../../../../components/Form/XSelect.vue"
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue"
import SeriesList from "../../Documents/partials/SeriesList.vue"
import LotsGroupList from "../../Documents/partials/LotsGroupList.vue"
import XCheckbox from "../../../../components/Form/XCheckbox.vue";
import XModal from "../../../../components/XModal.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";
import XSwitchLeft from "../../../../components/Form/XSwitchLeft.vue";

export default {
    name: 'DispatchItem',
    props: [
        'recordItem',
        'showDialog',
        'operationTypeId',
        'currencyTypeIdActive',
        'exchangeRateSale',
        'typeUser',
        'isEditItemNote',
        'configuration',
        'documentTypeId',
        'customerId',
        'currencyTypes',
        'isFromInvoice',
        'percentageIgv',
        'isCreditNoteAndType03',
        'isUpdateDocument',
        'table'
    ],
    components: {
        XSwitchLeft,
        XButtonCancel, XButtonSubmit,
        XModal,
        XCheckbox,
        LotsGroupList,
        SeriesList,
        XButtonPrimary,
        XSelect, XInput, XButtonIcon,
        ItemForm,
        Keypress,
        'vue-ckeditor': VueCkeditor.component
    },
    data() {
        return {
            loading: false,
            showDialogNewItem: false,
            showDiscounts: true,
            showWarehousesDetail: false,
            showDialogLots: false,
            showDialogSelectLots: false,
            showDialogSelectLotsGroup: false,
            extra_temp: undefined,
            can_add_new_product: false,
            loading_search: false,
            buttonLabel: '',
            is_client: false,
            title: '',
            resource: 'documents',
            has_list_prices: false,
            errors: {},
            form: {},
            all_items: [],
            items: [],
            operation_types: [],
            all_affectation_igv_types: [],
            aux_items: [],
            affectation_igv_types: [],
            system_isc_types: [],
            discount_types: [],
            charge_types: [],
            attribute_types: [],
            use_price: 1,
            change_affectation_igv_type_id: false,
            activePanel: 0,
            total_item: 0,
            item_unit_types: [],
            item_unit_type: {},
            warehousesDetail: [],
            showListStock: false,
            search_item_by_barcode: false,
            isUpdateWarehouseId: null,
            lots: [],
            editors: {
                classic: ClassicEditor
            },
            value1: 'hello',
            readonly_total: 0,
            itemLastPrice: null,
            search_item_by_barcode_presentation: false,
            history_item_id: null,
            loading_dialog: false,
            validate_stock_add_item: false,
            discounts: [],
            allLotsGroup: [],
            allLots: [],
            configurationItem: null
            //item_unit_type: {}
        }
    },
    created() {
        this.initForm()
    },
    async mounted() {
        await this.getTables()
        this.canCreateProduct();
    },
    computed: {
        ...mapState([
            'colors',
            'deb',
            'config',
        ]),
        canShowExtraData: function () {
            if (this.config && this.config.show_extra_info_to_item !== undefined) {
                return this.config.show_extra_info_to_item;
            }
            return false;
        },
        showLots() {
            return this.form.item_id && this.form.item.lots_enabled && !this.form.item.series_enabled
        },
        showSeries() {
            return this.form.item_id && this.form.item.series_enabled
        },
        documentItem() {
            if (this.recordItem !== undefined &&
                this.recordItem !== null &&
                this.recordItem.id !== undefined &&
                this.recordItem.id !== 0) {
                this.form.document_item_id = this.recordItem.id;
                this.form.id = this.recordItem.id;
                return this.recordItem.id;
            }
            return this.form.document_item_id;
        },
        enabledSearchFactoryCodeItems() {
            if (this.configuration) return this.configuration.search_factory_code_items ? 1 : 0
            return 0
        },
        isNoteErrorDescription() {
            if (this.isCreditNoteAndType03 !== undefined) return this.isCreditNoteAndType03
            return false
        },
        isOpenFromInvoice() {
            if (this.isFromInvoice !== undefined && this.isFromInvoice) return this.isFromInvoice

            return false
        },
        showSpecialData() {
            return (this.recordItem == null || this.recordItem == undefined) || (!_.isEmpty(this.recordItem) && this.isOpenFromInvoice)
        },
        applyRestrictSaleItemsCpe() {
            if (this.configuration) return this.configuration.restrict_sale_items_cpe

            return false
        },
        isRestrictedForSale() {
            return this.applyRestrictSaleItemsCpe && this.isOpenFromInvoice && (this.form.item != undefined && this.form.item.restrict_sale_cpe)
        },
        hasSelectedItem() {
            return this.form.item_id && !_.isEmpty(this.form.item)
        },
    },
    methods: {
        initForm() {
            this.errors = {};
            this.form = {
                id: null,
                // category_id: [1],
                // edit: false,
                item_id: null,
                item_name: null,
                // item_id: null,
                item: {},
                affectation_igv_type_id: null,
                affectation_igv_type: {},
                has_isc: false,
                system_isc_type_id: null,
                percentage_isc: 0,
                suggested_price: 0,
                quantity: 1,
                unit_price: 0,
                unit_price_value: 0,
                input_unit_price: 0,
                input_unit_price_value: 0,
                charges: [],
                discounts: [],
                attributes: [],
                has_igv: null,
                is_set: false,
                item_unit_types: [],
                has_plastic_bag_taxes: false,
                series_enabled: false,
                warehouse_id: null,
                lots: [],
                lots_group: [],
                IdLoteSelected: null,
                document_item_id: null,
                name_product_pdf: '',
                activate_discount_on_discount: true,
                name: null,
                is_item_free: false,
                weight: 0,
                comment: null
            };
            this.readonly_total = 0
            this.activePanel = 0;
            this.total_item = 0;
            this.item_unit_type = {};
            this.lots = []
            this.has_list_prices = false;
        },
        async getTables() {
            await this.$http.get(`/${this.resource}/item/tables`).then(response => {
                let data = response.data
                this.all_items = data.items
                this.operation_types = data.operation_types
                this.all_affectation_igv_types = data.affectation_igv_types
                this.system_isc_types = data.system_isc_types
                this.discount_types = data.discount_types
                this.charge_types = data.charge_types
                this.attribute_types = data.attribute_types
                this.is_client = data.is_client;
                this.validate_stock_add_item = data.validate_stock_add_item
                this.discounts = data.discounts
                this.itemFree = data.item_free
                this.configurationItem = data.configuration
                this.filterItems()
            })
        },
        ItemSlotTooltipView(item) {
            return ItemSlotTooltip(item);
        },
        ItemOptionDescriptionView(item) {
            return ItemOptionDescription(item)
        },
        canCreateProduct() {
            // if (this.typeUser === 'admin') {
            this.can_add_new_product = true
            // } else if (this.typeUser === 'seller') {
            //     if (this.configurationItem !== undefined && this.configurationItem.seller_can_create_product !== undefined) {
            //         this.can_add_new_product = this.configurationItem.seller_can_create_product;
            //     }
            // }
            return this.can_add_new_product;
        },
        validateQuantity() {

            if (!this.form.quantity) {
                this.setMinQuantity()
            }

            if (isNaN(Number(this.form.quantity))) {
                this.setMinQuantity()
            }

            if (typeof parseFloat(this.form.quantity) !== 'number') {
                this.setMinQuantity()
            }

            if (this.form.quantity <= this.getMinQuantity()) {
                this.setMinQuantity()
            }

            this.calculateTotal()
        },
        changeValidateQuantity(event) {
            this.calculateTotal()
        },
        getMinQuantity() {
            return 0
        },
        setMinQuantity() {
            this.form.quantity = this.getMinQuantity()
        },
        clickDecrease() {
            this.form.quantity = parseInt(this.form.quantity - 1)
            if (this.form.quantity <= this.getMinQuantity()) {
                this.setMinQuantity()
                return
            }
            this.calculateTotal()
        },
        clickIncrease() {
            this.form.quantity = parseInt(this.form.quantity) + 1
            this.calculateTotal()
        },
        async searchRemoteItems(input) {
            if (input.length > 2) {
                this.loading_search = true
                const params = {
                    'input': input,
                    'search_by_barcode': this.search_item_by_barcode ? 1 : 0,
                    'search_item_by_barcode_presentation': this.search_item_by_barcode_presentation ? 1 : 0,
                    'search_factory_code_items': this.enabledSearchFactoryCodeItems
                }
                await this.$http.get(`/${this.resource}/search-items/`, {params})
                    .then(response => {
                        this.items = response.data.items
                        this.loading_search = false
                        this.enabledSearchItemsBarcode(input)
                        this.enabledSearchItemBySeries()
                        if (this.items.length == 0) {
                            this.filterItems()
                        }
                    })
            } else {
                await this.filterItems()
            }

        },
        filterItems() {
            this.items = this.all_items
        },
        enabledSearchItemsBarcode(input) {
            if (this.search_item_by_barcode) {
                this.$refs.selectBarcode.$data.selectedLabel = '';
                //busqueda por presentacion
                if (this.search_item_by_barcode_presentation) {
                    if (this.items.length === 1) {
                        const item_unit_type = _.find(this.items[0].item_unit_types, {barcode: input})

                        if (!_.isEmpty(item_unit_type)) {
                            this.form.item_id = this.items[0].id;
                            this.$refs.selectBarcode.blur();
                            this.changeItem()
                            this.selectedPrice(item_unit_type)
                        }
                    }
                }
                //busqueda comun
                else {
                    if (this.items.length === 1) {
                        this.form.item_id = this.items[0].id;
                        this.$refs.selectBarcode.blur();
                        this.changeItem();
                    }
                }
            }
        },
        async enabledSearchItemBySeries() {
            if (this.config.search_item_by_series && this.items.length == 1) {
                this.$notify({title: "Serie ubicada", message: "Producto añadido!", type: "success", duration: 1200});
                this.form.item_id = this.items[0].id;
                this.$refs.selectSearchNormal.$data.selectedLabel = '';

                await this.changeItem();

                this.lots = await this.form.item.lots.map((lot) => {
                    lot.has_sale = true
                })

                await this.onSubmit()

                this.$refs.selectSearchNormal.$data.selectedLabel = '';
            }

            if (this.config.search_item_by_series && this.items.length == 0) {
                this.$notify({title: "Serie no ubicada", message: "", type: "warning", duration: 1200});
            }

        },
        filterMethod(query) {

            let item = _.find(this.items, {'internal_id': query});

            if (item) {
                this.form.item_id = item.id
                this.changeItem()
            }
        },
        clickWarehouseDetail() {

            if (!this.form.item_id) {
                return this.$message.error('Seleccione un item');
            }

            let item = _.find(this.items, {'id': this.form.item_id});

            this.warehousesDetail = item.warehouses
            this.showWarehousesDetail = true
        },
        async handleOpen() {
            this.initForm()
            this.extra_temp = undefined;
            this.title = (this.recordItem) ? ' Editar Producto o Servicio' : ' Agregar Producto o Servicio';
            this.buttonLabel = (this.recordItem) ? ' Editar' : ' Agregar';
            let operation_type = this.operation_types.find(row => {
                row.id === this.operationTypeId
            })
            if (operation_type) {
                this.affectation_igv_types = this.all_affectation_igv_types.filter(row => {
                    return row.exportation === operation_type.exportation
                })
            } else {
                this.affectation_igv_types = this.all_affectation_igv_types
            }

            if (this.recordItem) {
                this.form.id = this.recordItem.id
                if (this.recordItem.item !== undefined && this.recordItem.item.extra !== undefined) {
                    this.extra_temp = this.recordItem.item.extra
                }

                await this.reloadDataItems(this.recordItem.item_id)
                this.form.item_id = await this.recordItem.item_id
                await this.changeItem()
                this.form.quantity = this.recordItem.quantity
                this.form.unit_price_value = this.recordItem.input_unit_price_value
                this.form.has_plastic_bag_taxes = this.recordItem.total_plastic_bag_taxes > 0
                this.form.warehouse_id = this.recordItem.warehouse_id
                this.isUpdateWarehouseId = this.recordItem.warehouse_id
                this.form.lots = this.recordItem.lots
                this.form.IdLoteSelected = this.recordItem.IdLoteSelected

                this.form.discounts = this.recordItem.discounts
                if (this.isOpenFromInvoice) {
                    this.form.attributes = this.recordItem.attributes
                    this.form.charges = this.recordItem.charges
                }

                if (this.isEditItemNote) {
                    this.form.item.currency_type_id = this.currencyTypeIdActive
                    this.form.item.currency_type_symbol = (this.currencyTypeIdActive === 'PEN') ? 'S/' : '$'
                    if (this.documentTypeId === '07' && this.noteCreditOrDebitTypeId === '07') {
                        this.form.document_item_id = this.recordItem.id ? this.recordItem.id : this.recordItem.document_item_id
                        this.form.id = this.recordItem.id ? this.recordItem.id : this.recordItem.document_item_id
                        this.form.item.lots = this.recordItem.item.lots
                        this.lots = this.form.item.lots
                    }
                } else {
                    this.form.item.lots = this.recordItem.item.lots
                    this.lots = this.recordItem.item.lots
                }

                this.setPresentationEditItem()

                if (this.recordItem.item.name_product_pdf) {
                    this.form.name_product_pdf = this.recordItem.item.name_product_pdf
                }
                if (this.recordItem.name_product_pdf) {
                    this.form.name_product_pdf = this.recordItem.name_product_pdf
                }

                if (this.recordItem.item.change_free_affectation_igv) {

                    this.form.affectation_igv_type_id = '15'
                    this.form.item.change_free_affectation_igv = true

                } else {
                    if (this.recordItem.item.original_affectation_igv_type_id) {
                        this.form.affectation_igv_type_id = this.recordItem.item.original_affectation_igv_type_id
                    }
                }
                this.calculateQuantity()
                if (this.recordItem.item.exchanged_for_points) this.form.item.exchanged_for_points = this.recordItem.item.exchanged_for_points
            } else {
                this.isUpdateWarehouseId = null
            }

            this.setFocusSelectItem()
            // this.$refs.selectSearchNormal.$el.getElementsByTagName('input')[0].focus()
        },
        setPresentationEditItem() {
            if (!_.isEmpty(this.recordItem.item.presentation)) {
                this.selectedPrice(this.recordItem.item.presentation)
                this.getSelectedClass(this.recordItem.item.presentation)
            }
        },
        changeDiscountType(index) {
            let discount_type_id = this.form.discounts[index].discount_type_id
            this.form.discounts[index].discount_type = _.find(this.discount_types, {id: discount_type_id})
        },
        changeDiscountAmount(index) {
            //this.form.discounts[index].percentage = this.form.discounts[index].amount
        },
        changeType(index) {
            this.form.discounts[index].is_amount = (this.form.discounts[index].type !== '02')
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
        async changeItem() {
            this.form.item = _.find(this.items, {'id': this.form.item_id});
            this.form.item_unit_types = _.find(this.items, {'id': this.form.item_id}).item_unit_types
            this.form.unit_price_value = this.form.item.sale_unit_price;
            this.lots = this.form.item.lots

            this.form.has_igv = this.form.item.has_igv
            this.form.has_plastic_bag_taxes = this.form.item.has_plastic_bag_taxes
            this.form.affectation_igv_type_id = this.form.item.sale_affectation_igv_type_id
            if (this.form.item.series_enabled || this.form.item.lots_enabled) {
                this.form.quantity = 0
            } else {
                this.form.quantity = 1
            }
            this.cleanTotalItem()
            this.showListStock = true
            this.form.name = this.form.item.description
            this.form.weight = this.form.item.weight
            this.form.unit_type_id = this.form.item.unit_type_id
            this.form.has_isc = this.form.item.has_isc
            this.form.percentage_isc = this.form.item.percentage_isc
            this.form.system_isc_type_id = this.form.item.system_isc_type_id
            this.form.lots_group = this.form.item.lots_group
            this.allLotsGroup = this.form.item.lots_group
            this.allLots = this.form.item.lots
        },
        focusTotalItem(change) {
            if (!change && this.form.item.calculate_quantity) {
                this.$refs.total_item.$el.getElementsByTagName('input')[0].focus()
                this.total_item = this.form.unit_price_value
            }
        },
        calculateQuantity() {
            if (this.form.item.calculate_quantity) {
                this.form.quantity = _.round((this.total_item / this.form.unit_price_value), 4)
            }
            this.calculateTotal()
        },
        calculateTotal() {
            this.readonly_total = _.round((this.form.quantity * this.form.unit_price_value), 4)
        },
        cleanTotalItem() {
            this.total_item = null
        },
        async onSubmit() {
            // if (this.isRestrictedForSale) return this.$message.error('No puede agregar el producto, está restringido para venta.')
            //
            // if (this.applyValidateStock()) {
            //     const validate_current_stock = await this.validateCurrentStock()
            //     if (!validate_current_stock.success) return this.$message.error(validate_current_stock.message)
            // }

            // if (this.isNoteErrorDescription) {
            //     if (parseFloat(this.form.unit_price_value) < 0) return this.$message.error('El Precio Unitario debe ser mayor o igual 0');
            // } else {
            //     if (parseFloat(this.form.unit_price_value) <= 0) return this.$message.error('El Precio Unitario debe ser mayor a 0');
            // }

            if (parseFloat(this.form.quantity) === 0) {
                this.$message.error('La cantidad debe ser mayor a 0')
                return false
            }
            // if(this.form.quantity < this.getMinQuantity()){
            //     return this.$message.error(`La cantidad no puede ser inferior a ${this.getMinQuantity()}`);
            // }
            // this.validateQuantity()

            if (this.form.item.lots_enabled) {
                if (!this.form.IdLoteSelected)
                    return this.$message.error('Debe seleccionar lote.');
            }
            // let extra = this.form.item.extra

            // if (this.validateTotalItem().total_item) return;

            // let affectation_igv_type_id = this.form.affectation_igv_type_id
            // let unit_price = (this.form.has_igv) ? this.form.unit_price_value : this.form.unit_price_value * 1.18;
            // let unit_price = this.form.unit_price_value;
            // if (this.form.has_igv === false) {
            //     if (
            //         affectation_igv_type_id === "20" ||
            //         affectation_igv_type_id === "21" ||
            //         affectation_igv_type_id === "40"
            //     ) {
            //         // do nothing
            //         // exonerado de igv
            //     } else {
            //         unit_price = this.form.unit_price_value * (1 + this.percentageIgv);
            //
            //     }
            // }

            //validar precio compra y venta
            // if (this.configuration) {
            //     if (this.configuration.validate_purchase_sale_unit_price) {
            //         let val_purchase_unit_price = parseFloat(this.form.item.purchase_unit_price)
            //
            //         if (val_purchase_unit_price > parseFloat(unit_price)) {
            //             return this.$message.error(`El precio de compra no puede ser superior al precio de venta (P. Compra: ${val_purchase_unit_price})`)
            //         }
            //     }
            // }

            // this.form.input_unit_price_value = this.form.unit_price_value;

            // this.form.unit_price = unit_price;
            // this.form.item.unit_price = unit_price;
            // this.form.item.presentation = this.item_unit_type;
            // this.form.affectation_igv_type = _.find(this.affectation_igv_types, {'id': affectation_igv_type_id});

            let IdLoteSelected = this.form.IdLoteSelected
            let document_item_id = this.form.document_item_id

            if (this.form.is_item_free) {
                this.form.item.currency_type_id = this.currencyTypeIdActive
                if (this.form.item_name === '' || this.form.item_name === null) {
                    this.$message.error(`El nombre del producto libre es requerido`)
                    return
                }
            }

            // this.row = calculateRowItem(this.form, this.currencyTypeIdActive, this.exchangeRateSale, this.percentageIgv);

            // console.log(this.row)

            // this.row.item.name_product_pdf = this.row.name_product_pdf || '';
            // if (this.recordItem) {
            //     this.row.indexi = this.recordItem.indexi
            // }
            //
            // let select_lots = await _.filter(this.row.item.lots, {'has_sale': true})
            // let un_select_lots = await _.filter(this.row.item.lots, {'has_sale': false})

            // if (this.form.item.series_enabled) {
            // if (this.lotsSe.length != this.form.quantity)
            //     return this.$message.error('La cantidad de series seleccionadas son diferentes a la cantidad a vender');
            // }
            if (this.form.is_item_free) {
                this.form.item_id = this.itemFree.id;
                // this.row.item_name = this.form.item_name;
                this.form.item.description = this.form.item_name;
                this.form.unit_type_id = this.itemFree.unit_type_id;
                this.form.item.is_set = this.itemFree.is_set;
            }
            // else {
            //     this.form.item_name = null
            // }

            // this.row.item.extra = extra

            // if (this.recordItem) {
            //     this.row.indexi = this.recordItem.indexi
            // }

            // this.row.IdLoteSelected = IdLoteSelected
            // this.row.document_item_id = document_item_id
            this.$emit('add', this.form)
            this.initForm()

            if (this.search_item_by_barcode) {
                this.cleanItems()
            }
            if (this.recordItem) {
                this.clickClose();
            } else {
                this.setFocusSelectItem();
            }
        },
        cleanItems() {
            this.items = []
            this.$refs.selectBarcode.$el.getElementsByTagName('input')[0].focus()
        },
        validateTotalItem() {

            this.errors = {}

            if (this.form.item.calculate_quantity) {
                if (this.total_item < 0.01)
                    this.$set(this.errors, 'total_item', ['total venta item debe ser mayor a 0.01']);
            }

            return this.errors
        },
        async reloadDataItems(item_id) {
            if (!item_id) {
                await this.$http.get(`/${this.resource}/table/items`).then((response) => {
                    this.items = response.data
                    this.form.item_id = item_id
                })
            } else {
                await this.$http.get(`/${this.resource}/search/item/${item_id}`).then((response) => {
                    this.items = response.data.items
                    this.form.item_id = item_id
                    this.changeItem()
                })
            }
        },
        addRowLotGroup(id) {
            this.form.IdLoteSelected = id
        },
        clickLotGroup() {
            this.showDialogSelectLotsGroup = true
        },
        clickSelectLots() {
            this.showDialogSelectLots = true
        },
        addRowSelectLot(lots) {
            this.lots = lots
        },
        successSeries(data) {
            console.log(data)
            this.form.quantity = data.lots.length
            this.form.IdLoteSelected = data.lotsGroup
            this.form.lots = data.lots
            this.calculateTotal()
        },
        successLotsGroup(data) {
            this.form.quantity = data.quantity
            this.form.IdLoteSelected = data.lotsGroup
            this.calculateTotal()
        },
        focusSelectItem() {
            this.$refs.selectSearchNormal.$el.getElementsByTagName('input')[0].focus()
        },
        setFocusSelectItem() {
            this.$nextTick(() => {
                this.$refs.selectSearchNormal.$el.getElementsByTagName('input')[0].focus()
            });
        },
        checkKey(e) {
            let code = e.event.code;
            if (code === 'Escape') {
                this.clickClose()
            }
        },
        clickHistorySales() {
            if (!this.form.item_id) {
                return this.$message.error('Seleccione un item');
            }
            let item = _.find(this.items, {'id': this.form.item_id});
            this.history_item_id = item.id;
            this.showDialogHistorySales = true;
        },
        changeIsItemFree() {
            if (this.form.is_item_free) {
                this.form.item_id = this.itemFree.id;
                this.form.affectation_igv_type_id = '10';
            } else {
                this.form.item_id = null;
                this.form.affectation_igv_type_id = null;
            }
        },
        successItem(data) {
            this.form.item_id = data.id
            this.items = data.data.items
            this.changeItem()
        }
    }
}

</script>
